<template>
  <v-app  :dark="!light" :light="light">
    <v-toolbar app color="primary" :extended="!!filesCount">
      <v-avatar @click="getLocation">
        <v-img :src="require('./assets/pwa-logo.svg')">
        </v-img>
      </v-avatar>
      <v-toolbar-title class="title text-uppercase white--text">
        <span>VERDE SMART DATA</span>
        <br>
        <span class="font-weight-light"> ELIGIBIL PARC&#258;RI S4</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="_cbLogout" v-if="user" class="white--text">
        <v-icon>mdi-logout</v-icon>
      </v-btn>

      <template v-slot:extension v-if="!!filesCount">
        <div style="width: 100%">
          <v-progress-linear height="40" color="accent lighten-3" class="my-0" :value="progress">
            <div class="pl-2 white--text" style="display: flex; align-items: center; justify-content: space-between; height: 100%">
              <v-btn icon @click="openDeleteSheet" :disabled="!filesCount" class="ma-0">
                <v-icon color="error">mdi-delete</v-icon>
              </v-btn>
              <v-icon class="mr-2" color="white" @click="_cbToggleMessages">mdi-message-alert</v-icon>
              <span>{{filesDone}} din {{filesCount}} fisiere ({{filesSize}})</span>
              <v-icon :color="online === 'on' ? 'white' : online === 'off' ? 'red' : 'deep-orange accent-1'">
                <template v-if="online === 'on'">mdi-wifi-strength-4</template>
                <template v-else-if="online === 'off'">mdi-wifi-strength-off</template>
                <template v-else>mdi-wifi-strength-4-alert</template>
              </v-icon>
              <v-btn icon @click="startUpload" :disabled="online === 'off'" class="ma-0" v-if="workerStop">
                <v-icon color="white">mdi-cloud-upload</v-icon>
              </v-btn>
              <v-btn icon @click="pauseUpload" :disabled="online === 'off'" class="ma-0" v-else>
                <v-icon color="white">mdi-pause</v-icon>
              </v-btn>
            </div>
          </v-progress-linear>

          <v-progress-linear height="2" color="accent lighten-3" class="my-0" :value="progressOne">
          </v-progress-linear>
        </div>
      </template>
    </v-toolbar>

    <v-content>
      <transition :name="transitionName" mode="out-in">
        <router-view/>
      </transition>
    </v-content>

    <v-bottom-nav :value="true" app :color="light ? 'white' : 'grey darken-4 white--text'" :light="light">
      <v-btn flat color="primary" to="/">
        <span>Acasa</span>
        <v-icon>mdi-home</v-icon>
      </v-btn>
      <v-btn flat color="primary" to="/entities">
        <span>Simboluri</span>
        <v-icon>mdi-map-marker-radius</v-icon>
      </v-btn>
      <v-btn flat color="primary" to="/map">
        <span>Harta</span>
        <v-icon>mdi-map</v-icon>
      </v-btn>
      <v-btn flat color="primary" to="/photos">
        <span>Poze</span>
        <v-icon>mdi-image-multiple</v-icon>
      </v-btn>
      <v-btn flat color="primary" to="/dashboard" v-if="user && user.admin">
        <span>Dashboard</span>
        <v-icon>mdi-desktop-mac-dashboard</v-icon>
      </v-btn>
    </v-bottom-nav>

    <v-bottom-sheet v-model="deleteSheet">
      <v-list two-line dense style="max-height: 35vh; overflow-y: auto">
        <v-subheader>Elimina fisiere din lista de asteptare:</v-subheader>
        <v-list-tile
          v-for="file in files"
          :key="file.id">
          <v-list-tile-action style="color: grey">
            <v-icon small :color="file.tip === 'photo' ? 'primary' : 'error'">
              {{ file.tip === 'photo' ? 'mdi-camera' : 'mdi-file-pdf' }}
            </v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              {{ file.name }}
            </v-list-tile-title>
            <v-list-tile-sub-title>
              {{ prettyB(file.size) }}
              {{ (new Date(file.lastModified)).toLocaleString('ro-RO') }}
            </v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action @click="removeRef(file)">
            <v-btn icon v-if="!file.uploaded">
              <v-icon color="error">mdi-delete</v-icon>
            </v-btn>
            <v-icon color="primary" v-else>mdi-check</v-icon>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
    </v-bottom-sheet>

    <v-bottom-sheet v-model="messagesOpen">
      <v-list dense style="max-height: 35vh; overflow-y: auto">
        <v-subheader style="disdplay_flex; justify-content: space-between">
          Situatie incercari upload:
          <v-btn small icon @click="_cbClearMessages">
            <v-icon small color="error">mdi-delete-sweep</v-icon>
          </v-btn>
        </v-subheader>
        <v-list-tile
          v-for="message in messages"
          :key="message.id">
          <v-list-tile-action>
            <v-icon :color="message.type === 'fail' ? 'error' : 'success'">
              {{ message.tip === 'photo' ? 'mdi-camera' : (message.tip === 'pdf' ? 'mdi-file-pdf' : 'mdi-speedometer') }}
            </v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              {{ message.text}}
            </v-list-tile-title>
            <v-list-tile-sub-title>
              {{ message.timestamp.toLocaleDateString('ro-RO', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit'}) }}
            </v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-icon color="error" @click="_cbDeleteMessage(message.id)">
              mdi-delete
            </v-icon>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
    </v-bottom-sheet>
  </v-app>
</template>

<script>

import prettyBytes from 'pretty-bytes'
export default {
  name: 'App',
  data () {
    return {
      transitionName: 'slide-x-transition',
      deleteSheet: false
    }
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    loading () {
      return this.$store.getters.loading
    },
    light () {
      return this.$store.getters.light
    },
    online () {
      return this.$store.getters.online
    },
    files () {
      return this.$store.getters['entities/files']
    },
    filesCount () {
      return this.$store.getters['entities/filesCount']
    },
    filesSize () {
      return this.$store.getters['entities/filesSize']
    },
    filesDone () {
      return this.$store.getters['entities/filesDone']
    },
    progress () {
      return this.filesCount ? this.filesDone * 100 / this.filesCount : 100
    },
    progressOne () {
      return this.$store.getters['entities/progressOne']
    },
    workerStop () {
      return this.$store.getters['entities/workerStop']
    },
    messages () {
      return this.$store.getters.messages
    },
    messagesOpen: {
      get () {
        return this.$store.getters.messagesOpen
      },
      set (value) {
        this.$store.commit('setMessagesOpen', value)
      }
    }
  },
  watch: {
    filesCount (val) {
      if (!val && this.deleteSheet) this.deleteSheet = false
    }
  },
  methods: {
    prettyB (size) {
      return prettyBytes(size)
    },
    _cbLogout () {
      this.$store.dispatch('logout')
        .then(res => {
          this.$router.push({ name: 'login' })
        })
        .catch(err => {
          console.log('err', err)
          this.$router.push({ name: 'login' })
        })
    },
    getLocation () {
      this.$store.dispatch('getLocation')
    },
    startUpload () {
      if (this.online === 'lie-fi') {
        this.$dialog
          .confirm({
            title: 'Atentie!',
            body: 'Conexiunea la Internet este de tip LIE-FI (cea mai simpla comunicare cu serverul dureaza mai mult de 5 secunde). Esti sigur ca vrei sa incerci upload-ul?'
          }, {
            okText: 'DA',
            cancelText: 'Nu, incerc mai tarziu!',
            animation: 'zoom'
          })
          .then(dialog => {
            this.$store.dispatch('entities/uploadPhotos')
          })
          .catch(() => {})
      } else {
        this.$store.dispatch('entities/uploadPhotos')
      }
    },
    openDeleteSheet () {
      this.deleteSheet = true
    },
    removeRef (file) {
      if (!file.uploaded) this.$store.commit('entities/removeFile', file)
    },
    pauseUpload () {
      this.$store.dispatch('entities/pauseUpload')
    },
    _cbToggleMessages () {
      this.messagesOpen = !this.messagesOpen
    },
    _cbDeleteMessage (id) {
      this.$store.commit('deleteMessage', id)
    },
    _cbClearMessages () {
      this.$store.commit('deleteAllMessages')
    }
  }
}
</script>

<style lang="stylus">
details {
    border-radius: 4px;
    padding: .5em .5em 0;
}

summary {
    font-weight: bold;
    margin: -.5em -.5em 0;
    padding: .5em;
    outline: none;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    min-height: 50px;
    align-items: center;
}

details[open], details[open] summary {
    padding: .5em;
    // margin-bottom: .5em;
}

details[open] div::first-of-type {
    // border-bottom: 1px solid #aaa;
    margin-bottom: .5em;
    padding-left: 1em;
}

details input, details textarea, details summary.editable {
  color: var(--v-primary-base) !important;
}

.deletePhoto, .deletePdf {
  border: 2px solid var(--v-error-base) !important;
}

.normalPhoto, .normalPdf {
  border: 2px dashed var(--v-primary-base) !important;
}

.viewerPhoto {
  border: 2px solid var(--v-primary-base) !important;
}

.changelog p {
  text-align: justify;
}
</style>
